import React, { useEffect } from 'react'
import Header2 from '../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import ContactMain from '../components/contact/ContactMain'
import Info from '../components/contact/Info'
import { useLanguage } from '../contexts/LanguageContext'

const ContactPage = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

    return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>{t('seo.contactTitle')}</title>
        <meta name="description" content={t('seo.contactDescription')} />
    </Helmet>
    </HelmetProvider>
    <Header2/>
    <div style={{ overflow: 'hidden', backgroundImage: 'url("/bg-img/MicrosoftTeams-image.webp")', width: '100%', position: '', backgroundAttachment: 'fixed' }}>
      

      <ContactMain />
      <Info />
    </div>
    </>
  )
}

export default ContactPage